import { render, staticRenderFns } from "./switchOrg.vue?vue&type=template&id=7b2afc8f&scoped=true&"
import script from "./switchOrg.vue?vue&type=script&lang=js&"
export * from "./switchOrg.vue?vue&type=script&lang=js&"
import style0 from "./switchOrg.vue?vue&type=style&index=0&id=7b2afc8f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2afc8f",
  null
  
)

export default component.exports